<template>
  <div class="macro macro-component">
    <div class="list" v-if="!isClickMacro">
      <div
        class="fields"
        v-for="(key, index) in macroValue.keyOrder"
        :key="index"
      >
        <md-field class="field" v-if="typeof key === 'string'">
          <c-mouse-am35-virtual-keyboard
            class="key-input"
            v-if="activeIndex === index"
            :selectedKey="macroValue.keyOrder[index]"
            :text="getKey(key)"
            @change="onKeyChange(index, $event)"
            showMouse
            downAndUp
          />
          <md-input
            v-else
            :value="getKey(key)"
            readonly="readonly"
            class="key-input"
            @mouseover="activeIndex = index"
          ></md-input>
          <i
            v-show="state !== 'record'"
            class="key-remove iconfont iconclose"
            @click="onKeyRemove(index)"
          />
        </md-field>
        <div v-else class="xy">
          <md-field class="number">
            <span class="md-prefix">X</span>
            <md-input
              class="number-input"
              @change="
                macroValue.keyOrder[index].x = Number($event.target.value)
              "
              :value="macroValue.keyOrder[index].x"
              oninput="this.value = this.value.replace(/(?!^-)[^0-9]/g, '');
              this.value = this.value > 255 ? 255 : this.value;
              this.value = this.value < -255 ? -255 : this.value;"
            ></md-input>
          </md-field>
          <md-field class="number">
            <span class="md-prefix">Y</span>
            <md-input
              class="number-input"
              @change="
                macroValue.keyOrder[index].y = Number($event.target.value)
              "
              :value="macroValue.keyOrder[index].y"
              oninput="this.value = this.value.replace(/(?!^-)[^0-9]/g, '');
              this.value = this.value > 255 ? 255 : this.value;
              this.value = this.value < -255 ? -255 : this.value;"
            ></md-input>
          </md-field>
          <i
            v-show="state !== 'record'"
            class="key-remove iconfont iconclose"
            @click="onKeyRemove(index)"
          />
        </div>

        <template v-if="index === macroValue.keyOrder.length - 1">
          -
          <md-field class="field time">
            <md-input
              :value="macroValue.pressTime[index]"
              @blur="onTailLoopIntervalInput($event)"
              :disabled="state === 'record'"
              class="time-input"
            ></md-input>
            <span class="md-suffix">ms</span>
          </md-field>
          —
          <md-menu md-align-trigger class="tail-add-menu">
            <i
              v-show="state !== 'record'"
              md-menu-trigger
              class="key-add iconfont iconplus-o"
            />
            <md-menu-content>
              <md-menu-item @click="onKeyAdd">
                {{ $t("mouse.button") }}
              </md-menu-item>
              <md-menu-item @click="onXYAdd">
                {{ $t("mouse.coordinates") }}
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </template>
        <template v-else>
          -
          <md-field class="field time">
            <md-input
              v-model="macroValue.pressTime[index]"
              @blur="onIntervalInput(index, $event)"
              :disabled="state === 'record'"
              class="time-input"
            ></md-input>
            <span class="md-suffix">ms</span>
          </md-field>
          —
        </template>
      </div>
    </div>
    <div class="click-editor" v-else>
      <div class="click-editor-inner">
        <div class="click-field click-field-key">
          <div class="click-label">{{ $t("mouse.button") }}</div>
          <c-mouse-am35-virtual-keyboard
            class="click-key-input"
            :selectedKey="clickKey"
            @change="onClickMacroKeyChange"
            showMouse
            compact
          />
        </div>
        <div class="click-field">
          <div class="click-label">{{ $t("mouse.buttonInterval") }}</div>
          <md-field class="click-input-field">
            <md-input
              class="click-input"
              :value="clickInterval"
              @blur="onClickIntervalInput"
              @keypress.enter="onClickIntervalInput"
              oninput="this.value = this.value.replace(/[^0-9]/g, '');
              this.value = this.value > 60000 ? 60000 : this.value;"
            ></md-input>
            <span class="md-suffix">ms</span>
          </md-field>
        </div>
        <div class="click-field">
          <div class="click-label">{{ $t("mouse.repeat") }}</div>
          <md-field class="click-input-field">
            <md-input
              class="click-input"
              :value="clickRepeatTimes"
              @blur="onClickRepeatTimesInput"
              @keypress.enter="onClickRepeatTimesInput"
              oninput="this.value = this.value.replace(/[^0-9]/g, '');
              this.value = this.value > 65535 ? 65535 : this.value;
              this.value = this.value < 1 ? 1 : this.value;"
            ></md-input>
          </md-field>
        </div>
      </div>
    </div>
    <div
      class="buttons"
      @mousedown.stop
      @mouseup.stop
      style="flex-wrap: nowrap;"
    >
      {{ $t("keyboard.macro.select") }}
      <md-field class="macro-field">
        <md-select
          v-model="macroIndex"
          :disabled="state === 'record'"
          class="macro-select"
          @md-selected="onMacroChange"
          :placeholder="$t('keyboard.macro.select')"
        >
          <template v-for="(macro, index) in macroData">
            <md-option :value="index" :key="'macro_key' + index">
              {{ getMacroOptionLabel(macro) }}
            </md-option>
          </template>
        </md-select>
      </md-field>
      {{ $t("mouse.rename") }}
      <md-field class="macro-name">
        <md-input
          class="input"
          v-model="macroName"
          @blur="onSave"
          @keypress.enter="onSave"
        ></md-input>
      </md-field>
      <span v-if="!isClickMacro">
        {{ $t("mouse.allInterval") }}
      </span>
      <md-field v-if="!isClickMacro" class="all-time">
        <md-input
          class="input"
          :value="allInterval"
          @blur="onAllIntervalInput"
          @keypress.enter="onAllIntervalInput"
          :disabled="state === 'record'"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
      <span v-else>
        {{ $t("mouse.macroInterval") }}
      </span>
      <md-field v-if="isClickMacro" class="all-time macro-loop-interval">
        <md-input
          class="input"
          :value="macroLoopIntervalInput"
          @input="onMacroLoopIntervalInput"
          @blur="onMacroLoopIntervalChange"
          @keypress.enter="onMacroLoopIntervalChange"
          :disabled="state === 'record'"
        ></md-input>
        <span class="md-suffix">ms</span>
      </md-field>
      <a-radio-group
        class="radio-group"
        :class="{ 'radio-group-click': isClickMacro }"
        value="none"
        size="large"
      >
        <a-radio-button
          v-if="isClickMacro"
          class="macro-hidden-button macro-leading-placeholder"
          disabled
        >
          {{ $t("keyboard.macro.record") }} ●
        </a-radio-button>
        <div class="macro-add-menu">
          <a-radio-button
            class="macro-add-button"
            :disabled="state === 'record'"
            @click.stop="toggleAddMacroMenu"
          >
            {{ $t("keyboard.macro.add") }}
          </a-radio-button>
          <div v-if="addMacroMenuVisible" class="macro-type-menu">
            <div
              class="macro-type-menu-item"
              @click.stop="onAddMacroTypeSelect('normal')"
            >
              {{ $t("macro") }}
            </div>
            <div
              class="macro-type-menu-item"
              @click.stop="onAddMacroTypeSelect('click')"
            >
              {{ $t("mouse.clickMacro") }}
            </div>
          </div>
        </div>
        <a-radio-button
          :disabled="state === 'record' || macroIndex < 0"
          @click="onRemove"
        >
          {{ $t("keyboard.macro.remove") }}
        </a-radio-button>
        <a-radio-button
          v-if="!isClickMacro && state === 'stop'"
          :disabled="macroIndex < 0"
          @click="onRecord"
        >
          {{ $t("keyboard.macro.record") }} ●
        </a-radio-button>
        <a-radio-button
          v-else-if="!isClickMacro && state === 'record'"
          :class="{ active: state === 'record' }"
          :disabled="macroIndex < 0"
          @click="onRecordStop"
        >
          {{ $t("keyboard.macro.stop") }} ■
        </a-radio-button>
        <a-radio-button
          :class="{ active: saveActive }"
          :disabled="state === 'record' || macroIndex < 0"
          @click="onSave"
        >
          {{ $t("save") }}
        </a-radio-button>
      </a-radio-group>
    </div>
    <div class="buttons" v-if="false">
      <div class="title">
        {{ $t("mouse.offset") }}
        <md-switch
          class="md-primary switch"
          v-model="offsetSwitch"
          @change="onSave"
        ></md-switch>
        {{ $t("mouse.space") }}
        <a-progress
          class="progress"
          :stroke-color="{
            '0%': '#4136f1',
            '100%': '#8743ff',
          }"
          :percent="parseInt(macroValue.keyOrder.length / 0.42)"
          status="active"
        />
      </div>
      <div class="offset" v-show="offsetSwitch">
        {{ $t("mouse.timeOffset") }}
        <a-slider
          class="slider"
          :value="timeOffset - 1"
          @change="onTimeOffsetChange"
          :min="0"
          :max="254"
          :tooltipVisible="false"
        />
        <md-field class="offset-input">
          <md-input
            class="input"
            :value="timeOffset - 1"
            @blur="onTimeOffsetChange($event.target.value)"
            @keypress.enter="onTimeOffsetChange($event.target.value)"
            min="0"
            max="254"
            step="1"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 254 ? 254 : this.value;
          this.value = this.value < 0 ? 0 : this.value;"
          ></md-input>
        </md-field>
        {{ $t("mouse.xyOffset") }}
        <a-slider
          class="slider"
          :value="xyOffset - 1"
          @change="onXyOffsetChange"
          :min="0"
          :max="254"
          :tooltipVisible="false"
        />
        <md-field class="offset-input">
          <md-input
            class="input"
            :value="xyOffset - 1"
            @blur="onXyOffsetChange($event.target.value)"
            @keypress.enter="onXyOffsetChange($event.target.value)"
            min="0"
            max="254"
            step="1"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');
          this.value = this.value > 254 ? 254 : this.value;
          this.value = this.value < 0 ? 0 : this.value;"
          ></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { codeKeys } from "../mouse";
import { deepCopy } from "@/utils";

const MAX_MACRO_KEYS = 33;
const MAX_MACRO_EVENTS = MAX_MACRO_KEYS * 2;
const CLICK_MACRO_DEFAULT_KEY = "0xf0";
const CLICK_MACRO_DEFAULT_INTERVAL = 30;
const CLICK_MACRO_DEFAULT_REPEAT_TIMES = 3;
const CLICK_MACRO_MIN_INTERVAL = 1;
const CLICK_MACRO_MAX_INTERVAL = 60000;
const CLICK_MACRO_MIN_REPEAT_TIMES = 1;
const CLICK_MACRO_MAX_REPEAT_TIMES = MAX_MACRO_KEYS;
const CLICK_MACRO_DURATION = 1;
const CLICK_MACRO_TAIL_DELAY = 50;
const DEFAULT_TAIL_INTERVAL = 50;

export default {
  name: "CMouseAm35Macro",
  data() {
    return {
      codeKeys,
      macroLength: 0,
      state: "stop",
      time: 0,
      activeIndex: -1,
      minInterval: 1,
      macroIndex: -1,
      macroValue: {
        keyOrder: [],
        pressTime: [],
      },
      macroName: "",
      allInterval: null,
      clickKey: CLICK_MACRO_DEFAULT_KEY,
      clickInterval: CLICK_MACRO_DEFAULT_INTERVAL,
      clickRepeatTimes: CLICK_MACRO_DEFAULT_REPEAT_TIMES,
      macroLoopInterval: DEFAULT_TAIL_INTERVAL,
      macroLoopIntervalInput: String(DEFAULT_TAIL_INTERVAL),
      addMacroMenuVisible: false,
      offsetSwitch: false,
      timeOffset: 1,
      xyOffset: 1,
      timer: 0,
    };
  },
  computed: {
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("mouseAM35", {
      keyMatrix: "keyMatrix",
      macroData: "macroData",
      mouseMacroData: "mouseMacroData",
    }),
    currentMacro() {
      if (this.macroIndex < 0 || !this.macroData?.[this.macroIndex]) {
        return null;
      }
      return this.macroData[this.macroIndex];
    },
    isClickMacro() {
      return this.currentMacro?.macro_type === "click";
    },
    saveActive() {
      if (this.state === "record") return false;
      if (this.macroIndex < 0) return false;
      if (!this.macroData || !this.macroData[this.macroIndex]) return false;
      if (this.macroName !== this.currentMacro.macro_name) {
        return true;
      }
      if (this.isClickMacro) {
        if (
          this.clickKey !== this.currentMacro.click_key ||
          this.clickInterval !== this.currentMacro.click_interval ||
          this.clickRepeatTimes !== this.currentMacro.click_repeat_times ||
          this.macroLoopInterval !== this.getMacroLoopIntervalValue(this.currentMacro)
        ) {
          return true;
        }
      } else if (
        JSON.stringify(this.macroValue) !==
        JSON.stringify(this.currentMacro.macroValue)
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // macroValue: {
    //   handler(newVal) {
    //     console.log("=== macroValue 变化 ===");
    //     console.log("keyOrder:", JSON.parse(JSON.stringify(newVal.keyOrder)));
    //     console.log("pressTime:", JSON.parse(JSON.stringify(newVal.pressTime)));
    //     console.log("完整结构:", JSON.parse(JSON.stringify(newVal)));
    //     console.log("========================");
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  methods: {
    normalizeMacroLoopInterval(value, fallback = DEFAULT_TAIL_INTERVAL) {
      const numericValue = parseInt(String(value ?? "").replace(/[^0-9]/g, ""), 10);
      if (!Number.isFinite(numericValue)) {
        return fallback;
      }
      if (numericValue < 0) {
        return 0;
      }
      if (numericValue > 65535) {
        return 65535;
      }
      return numericValue;
    },
    normalizeClickInterval(value) {
      const numericValue = parseInt(String(value).replace(/[^0-9]/g, ""), 10) || 0;
      return Math.min(
        CLICK_MACRO_MAX_INTERVAL,
        Math.max(CLICK_MACRO_MIN_INTERVAL, numericValue)
      );
    },
    normalizeClickRepeatTimes(value) {
      const numericValue = parseInt(String(value).replace(/[^0-9]/g, ""), 10) || 0;
      return Math.min(
        CLICK_MACRO_MAX_REPEAT_TIMES,
        Math.max(CLICK_MACRO_MIN_REPEAT_TIMES, numericValue)
      );
    },
    isMacroAction(item) {
      return typeof item !== "string" || item.startsWith("0x11");
    },
    isMacroValueWithinLimits(macroValue = this.macroValue) {
      const keyOrder = macroValue?.keyOrder;
      return (
        Array.isArray(keyOrder) &&
        keyOrder.length <= MAX_MACRO_EVENTS &&
        keyOrder.filter((item) => this.isMacroAction(item)).length <=
          MAX_MACRO_KEYS
      );
    },
    areMacroValuesWithinLimits(macroData) {
      return macroData.every((macro) =>
        this.isMacroValueWithinLimits(macro.macroValue)
      );
    },
    canAppendMacroEvent(item) {
      const keyOrder = this.macroValue.keyOrder.concat(item);
      return this.isMacroValueWithinLimits({ keyOrder });
    },
    appendRecordedMacroEvent(item) {
      if (!this.canAppendMacroEvent(item)) return false;
      const keyOrder = this.macroValue.keyOrder;
      keyOrder.push(item);
      const now = Date.now();
      const time = now - this.time;
      const timeIndex = keyOrder.length - 2;
      if (timeIndex >= 0) {
        this.macroValue.pressTime[timeIndex] =
          time > this.minInterval ? time : this.minInterval;
      }
      this.time = now;
      return true;
    },
    getMacroLoopIntervalValue(macro, fallback = DEFAULT_TAIL_INTERVAL) {
      return this.normalizeMacroLoopInterval(
        macro?.setAM35MacroLoopInterval?.interval,
        fallback
      );
    },
    buildClickMacroValue() {
      const keyOrder = [];
      const pressTime = [];
      const clickKey = this.clickKey || CLICK_MACRO_DEFAULT_KEY;
      const downKey = clickKey.replace("0x", "0x11");
      const upKey = clickKey.replace("0x", "0x10");

      for (let index = 0; index < this.clickRepeatTimes; index++) {
        keyOrder.push(downKey);
        pressTime.push(CLICK_MACRO_DURATION);
        keyOrder.push(upKey);
        pressTime.push(
          index === this.clickRepeatTimes - 1
            ? CLICK_MACRO_TAIL_DELAY
            : this.clickInterval
        );
      }

      return {
        keyOrder,
        pressTime,
      };
    },
    syncClickMacroValue() {
      this.clickKey = this.clickKey || CLICK_MACRO_DEFAULT_KEY;
      this.clickInterval = this.normalizeClickInterval(this.clickInterval);
      this.macroValue = this.buildClickMacroValue();
    },
    normalizeMacroValueForSave() {
      const keyOrderLength = this.macroValue.keyOrder.length;
      const pressTime = this.macroValue.keyOrder.map((_, index) => {
        const currentValue = this.macroValue.pressTime[index];
        if (index === keyOrderLength - 1) {
          return this.normalizeMacroLoopInterval(currentValue);
        }
        let numericValue = parseInt(String(currentValue ?? "").replace(/[^0-9]/g, ""), 10);
        if (!Number.isFinite(numericValue) || numericValue < this.minInterval) {
          numericValue = this.minInterval;
        }
        if (numericValue > 60000) {
          numericValue = 60000;
        }
        return numericValue;
      });
      return {
        ...deepCopy(this.macroValue),
        pressTime,
      };
    },
    buildMacroLoopIntervalPayload() {
      if (this.isClickMacro) {
        return {
          interval: this.macroLoopInterval,
        };
      }
      const lastIndex = this.macroValue.keyOrder.length - 1;
      if (lastIndex < 0) {
        return {};
      }
      return {
        interval: this.normalizeMacroLoopInterval(this.macroValue.pressTime[lastIndex]),
      };
    },
    syncEditorFromMacro(macro) {
      this.macroValue = deepCopy(macro.macroValue || { keyOrder: [], pressTime: [] });
      this.macroName = macro.macro_name || "";
      this.offsetSwitch = macro.offsetSwitch === 1;
      this.timeOffset = macro.timeOffset || 1;
      this.xyOffset = macro.xyOffset || 1;
      this.clickKey = macro.click_key || CLICK_MACRO_DEFAULT_KEY;
      this.clickInterval = macro.click_interval || CLICK_MACRO_DEFAULT_INTERVAL;
      this.clickRepeatTimes =
        macro.click_repeat_times || CLICK_MACRO_DEFAULT_REPEAT_TIMES;
      this.macroLoopInterval = this.getMacroLoopIntervalValue(macro);
      this.macroLoopIntervalInput = String(this.macroLoopInterval);
      this.allInterval = null;
    },
    getMacroOptionLabel(macro) {
      if (macro?.macro_type === "click") {
        return `${macro.macro_name}（${this.$t("mouse.clickMacro")}）`;
      }
      return macro?.macro_name || "";
    },
    toggleAddMacroMenu() {
      if (this.state === "record") return;
      this.addMacroMenuVisible = !this.addMacroMenuVisible;
    },
    closeAddMacroMenu() {
      this.addMacroMenuVisible = false;
    },
    onAddMacroTypeSelect(macroType) {
      this.closeAddMacroMenu();
      this.onAddMacro(macroType);
    },
    onDocumentClick(event) {
      if (event.target.closest(".macro-add-menu")) return;
      this.closeAddMacroMenu();
    },
    onInit() {
      this.disabled = false;
      console.log("onInit", this.macroData);
      this.state = "stop";
      if (this.macroData?.length) {
        if (this.macroIndex < 0) {
          this.macroIndex = 0;
          this.syncEditorFromMacro(this.macroData[0]);
        }
      }
      // this.macroLength = this.macroData.reduce((acc, item) => {
      //   return acc + item.macroValue.keyOrder.length;
      // }, 0);
    },
    onMacroChange(index) {
      if (!this.macroData || !this.macroData[index]) return;
      this.macroIndex = index;
      this.syncEditorFromMacro(this.macroData[index]);
    },
    onAllIntervalInput(e) {
      let time = e.target.value;
      time = parseInt(time.replace(/[^0-9]/g, "")) || 0;
      if (time < this.minInterval) time = this.minInterval;
      if (time > 60000) time = 60000;
      this.macroValue.pressTime.fill(time);
      this.macroValue = { ...this.macroValue };
      this.allInterval = time;
      this.onSave();
    },
    onAddMacro(macroType = "normal") {
      this.closeAddMacroMenu();
      this.state = "stop";
      this.macroIndex = this.macroData.length;
      let index = 0;
      while (
        this.macroData.findIndex((i) => i.index === index) > -1 ||
        this.macroData.findIndex((i) => i.macro_name === "M_" + index) > -1
      ) {
        index++;
      }
      const nextMacro = {
        index,
        macro_name: "M_" + index,
        macro_type: macroType === "click" ? "click" : "normal",
        macroValue: {
          keyOrder: [],
          pressTime: [],
        },
        keyID: 0,
        toKeyID: "",
        repeat_mode: 0,
        repeat_times: 1,
        setAM35MacroLoopInterval: {
          interval: DEFAULT_TAIL_INTERVAL,
        },
      };
      if (nextMacro.macro_type === "click") {
        nextMacro.click_key = CLICK_MACRO_DEFAULT_KEY;
        nextMacro.click_interval = CLICK_MACRO_DEFAULT_INTERVAL;
        nextMacro.click_repeat_times = CLICK_MACRO_DEFAULT_REPEAT_TIMES;
      }
      this.macroName = nextMacro.macro_name;
      this.clickKey = nextMacro.click_key || CLICK_MACRO_DEFAULT_KEY;
      this.clickInterval = nextMacro.click_interval || CLICK_MACRO_DEFAULT_INTERVAL;
      this.clickRepeatTimes =
        nextMacro.click_repeat_times || CLICK_MACRO_DEFAULT_REPEAT_TIMES;
      this.macroLoopInterval = DEFAULT_TAIL_INTERVAL;
      this.macroLoopIntervalInput = String(DEFAULT_TAIL_INTERVAL);
      this.macroValue =
        nextMacro.macro_type === "click"
          ? this.buildClickMacroValue()
          : { keyOrder: [], pressTime: [] };
      this.$store.dispatch("mouseAM35/setMacroData", [
        ...this.macroData,
        nextMacro,
      ]);
    },
    getKey(key) {
      const text = Object.keys(codeKeys).find((k) => codeKeys[k] === key);
      return (text || key)
        .replace("Key", "")
        .replace("Digit", "")
        .replace("Meta", "Code");
    },
    onKeyRemove(index) {
      this.macroValue.keyOrder.splice(index, 1);
      this.macroValue.pressTime.splice(index, 1);
      this.macroValue = { ...this.macroValue };
    },
    onKeyChange(index, value) {
      const keyOrder = this.macroValue.keyOrder.slice();
      keyOrder[index] = value;
      if (!this.isMacroValueWithinLimits({ keyOrder })) {
        return;
      }
      this.macroValue.keyOrder[index] = value;
      this.macroValue = { ...this.macroValue };
    },
    onIntervalInput(index, e) {
      let time = e.target.value;
      time = parseInt(time.replace(/[^0-9]/g, "")) || 0;
      if (time < this.minInterval) time = this.minInterval;
      if (time > 60000) time = 60000;
      this.macroValue.pressTime[index] = Math.floor(time);
      this.macroValue = { ...this.macroValue };
    },
    onTailLoopIntervalInput(e) {
      const loopIntervalIndex = this.macroValue.keyOrder.length - 1;
      if (loopIntervalIndex < 0) return;
      this.macroValue.pressTime[loopIntervalIndex] = this.normalizeMacroLoopInterval(
        e.target.value
      );
      this.macroValue = { ...this.macroValue };
    },
    onKeyAdd() {
      if (!this.canAppendMacroEvent("0x1104")) return;
      this.macroValue.keyOrder.push("0x1104");
      this.macroValue.pressTime.push(this.minInterval);
      this.macroValue = { ...this.macroValue };
    },
    onXYAdd() {
      const coordinate = { x: 0, y: 0 };
      if (!this.canAppendMacroEvent(coordinate)) return;
      this.macroValue.keyOrder.push(coordinate);
      this.macroValue.pressTime.push(this.minInterval);
      this.macroValue = { ...this.macroValue };
    },
    onTimeOffsetChange(value) {
      this.timeOffset = Number(value) + 1;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.onSave, 200);
    },
    onXyOffsetChange(value) {
      this.xyOffset = Number(value) + 1;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(this.onSave, 200);
    },
    isBoundMacroMapping(mapping, macroName) {
      return (
        Array.isArray(mapping) &&
        (mapping[0] == "8" || mapping[0] == 8) &&
        mapping[3] === macroName
      );
    },
    buildBoundMacroMapping(mapping, macroName, macroPayload) {
      return [8, mapping[1] ?? 0, mapping[2] ?? 1, macroName, macroPayload];
    },
    clearBoundMacroKeys(macroName) {
      const nextKeyMatrix = { ...this.keyMatrix };
      let hasChanged = false;

      for (const key in nextKeyMatrix) {
        const mapping = nextKeyMatrix[key];
        if (!this.isBoundMacroMapping(mapping, macroName)) continue;

        const keyID = key.replace("0x0", "");
        this.$store.dispatch("loader/changeAM35MouseKey", {
          keyID,
          toKeyID: keyID,
          payload: [],
          macro_name: "",
          repeat_mode: "",
          repeat_times: "",
          setAM35MacroLoopInterval: {},
        });
        nextKeyMatrix[key] = [keyID];
        hasChanged = true;
      }

      if (hasChanged) {
        this.$store.dispatch("mouseAM35/setKeyMatrix", nextKeyMatrix);
      }
    },
    syncBoundMacroKeys(
      oldMacroName,
      nextMacroName,
      macroPayload,
      macroLoopInterval = {}
    ) {
      const nextKeyMatrix = { ...this.keyMatrix };
      let hasChanged = false;

      for (const key in nextKeyMatrix) {
        const mapping = nextKeyMatrix[key];
        if (!this.isBoundMacroMapping(mapping, oldMacroName)) continue;

        const keyID = key.replace("0x0", "");
        const repeatMode = mapping[1] ?? 0;
        const repeatTimes = mapping[2] ?? 1;
        nextKeyMatrix[key] = this.buildBoundMacroMapping(
          mapping,
          nextMacroName,
          macroPayload
        );
        this.$store.dispatch("loader/changeAM35MouseKey", {
          keyID,
          toKeyID: 8,
          payload: macroPayload,
          macro_name: nextMacroName,
          repeat_mode: repeatMode,
          repeat_times: repeatTimes,
          setAM35MacroLoopInterval: {
            interval: this.normalizeMacroLoopInterval(
              macroLoopInterval?.interval,
              DEFAULT_TAIL_INTERVAL
            ),
          },
        });
        hasChanged = true;
      }

      if (hasChanged) {
        this.$store.dispatch("mouseAM35/setKeyMatrix", nextKeyMatrix);
      }
    },
    onRemove() {
      this.$confirm({
        title: this.$t("keyboard.macro.removeConfirm"),
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
        onOk: () => {
          const macroData = [...this.macroData];
          const macro = macroData.splice(this.macroIndex, 1);
          if (!this.areMacroValuesWithinLimits(macroData)) return;
          this.state = "stop";
          this.macroIndex = -1;
          this.macroValue = {
            keyOrder: [],
            pressTime: [],
          };
          this.macroName = "";
          this.clickKey = CLICK_MACRO_DEFAULT_KEY;
          this.clickInterval = CLICK_MACRO_DEFAULT_INTERVAL;
          this.clickRepeatTimes = CLICK_MACRO_DEFAULT_REPEAT_TIMES;
          this.$store.dispatch("mouseAM35/setMacroData", macroData);
          this.$store
            .dispatch("loader/saveAM35macro", this.mouseMacroData)
            .then(() => {
              this.$message.info(this.$t("loader.saveSuccess"));
            });
          this.clearBoundMacroKeys(macro[0].macro_name);
        },
      });
    },
    onRecord() {
      if (this.isClickMacro) return;
      this.macroValue = {
        keyOrder: [],
        pressTime: [],
      };
      this.state = "record";
    },
    onRecordStop() {
      const lastIndex = this.macroValue.keyOrder.length - 1;
      if (lastIndex >= 0 && this.macroValue.pressTime[lastIndex] == null) {
        this.macroValue.pressTime[lastIndex] = DEFAULT_TAIL_INTERVAL;
        this.macroValue = { ...this.macroValue };
      }
      this.state = "stop";
    },
    onClickMacroKeyChange(value) {
      this.clickKey = value;
      this.syncClickMacroValue();
    },
    onClickIntervalInput(e) {
      this.clickInterval = this.normalizeClickInterval(e.target.value);
      this.syncClickMacroValue();
    },
    onClickRepeatTimesInput(e) {
      this.clickRepeatTimes = this.normalizeClickRepeatTimes(e.target.value);
      this.syncClickMacroValue();
    },
    onMacroLoopIntervalInput(e) {
      const value = e?.target ? e.target.value : e;
      const inputValue = String(value ?? "").replace(/[^0-9]/g, "");
      this.macroLoopIntervalInput = inputValue;
    },
    onMacroLoopIntervalChange(e) {
      const nextInterval = this.normalizeMacroLoopInterval(
        e.target.value,
        this.macroLoopInterval
      );
      this.macroLoopInterval = nextInterval;
      this.macroLoopIntervalInput = String(nextInterval);
    },
    onSave() {
      const macroData = [...this.macroData];
      const oldName = macroData[this.macroIndex].macro_name;
      const macroName = this.macroName;
      if (
        macroName != macroData[this.macroIndex].macro_name &&
        macroData.find((i) => i.macro_name == macroName)
      ) {
        this.$message.info(this.$t("keyboard.macro.nameDuplicated"));
        return;
      }
      if (!this.isMacroValueWithinLimits()) return;
      if (this.isClickMacro) this.syncClickMacroValue();
      if (this.isClickMacro) {
        this.macroLoopInterval = this.normalizeMacroLoopInterval(
          this.macroLoopIntervalInput,
          this.macroLoopInterval
        );
        this.macroLoopIntervalInput = String(this.macroLoopInterval);
        macroData[this.macroIndex] = {
          ...macroData[this.macroIndex],
          macro_name: macroName,
          macro_type: "click",
          repeat_mode: Number(this.repeatMode ?? 0),
          repeat_times: this.repeatMode === 0 ? this.repeatTimes : 0,
          click_key: this.clickKey,
          click_interval: this.clickInterval,
          click_repeat_times: this.clickRepeatTimes,
          macroValue: deepCopy(this.macroValue),
          setAM35MacroLoopInterval: this.buildMacroLoopIntervalPayload(),
        };
      } else {
        const normalizedMacroValue = this.normalizeMacroValueForSave();
        macroData[this.macroIndex] = {
          ...macroData[this.macroIndex],
          macro_name: macroName,
          macro_type: "normal",
          macroValue: normalizedMacroValue,
          setAM35MacroLoopInterval: this.buildMacroLoopIntervalPayload(),
        };
      }
      if (!this.areMacroValuesWithinLimits(macroData)) return;
      this.macroValue = deepCopy(macroData[this.macroIndex].macroValue);
      // macroData[this.macroIndex].offsetSwitch = this.offsetSwitch ? 1 : 0;
      // macroData[this.macroIndex].timeOffset = this.offsetSwitch
      //   ? this.timeOffset
      //   : 0;
      // macroData[this.macroIndex].xyOffset = this.offsetSwitch
      //   ? this.xyOffset
      //   : 0;

      this.$store.dispatch("mouseAM35/setMacroData", macroData);
      this.$store
        .dispatch("loader/saveAM35macro", this.mouseMacroData)
        .then(() => {
          this.$message.info(this.$t("loader.saveSuccess"));
        });
      const savedMacro = macroData[this.macroIndex] || {};
      const macroPayload =
        this.mouseMacroData.find((macro) => macro.macro_name === macroName)
          ?.macroValue?.keyOrder || [];
      const macroLoopInterval =
        savedMacro?.setAM35MacroLoopInterval || this.buildMacroLoopIntervalPayload();
      this.syncBoundMacroKeys(
        oldName,
        macroName,
        macroPayload,
        macroLoopInterval
      );
    },
    onKeyDown(event) {
      if (this.state === "record") {
        const downKey = codeKeys["↓" + event.code];
        if (!downKey) return;
        const downIndex = this.macroValue.keyOrder.lastIndexOf(downKey);
        const upKey = codeKeys["↑" + event.code];
        const upIndex = this.macroValue.keyOrder.lastIndexOf(upKey);
        if (downIndex === -1 || upIndex > downIndex) {
          this.appendRecordedMacroEvent(downKey);
        }
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    onKeyUp(event) {
      if (this.state === "record") {
        const downKey = codeKeys["↑" + event.code];
        if (!downKey) return;
        this.appendRecordedMacroEvent(downKey);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
    onMouseDown(event) {
      if (this.state === "record") {
        const code = [
          "MouseLeft",
          "MouseWheel",
          "MouseRight",
          "MouseBack",
          "MouseForward",
        ][event.button];
        if (!code) return;
        const downKey = codeKeys["↓" + code];
        const downIndex = this.macroValue.keyOrder.lastIndexOf(downKey);
        const upKey = codeKeys["↑" + code];
        const upIndex = this.macroValue.keyOrder.lastIndexOf(upKey);
        if (downIndex === -1 || upIndex > downIndex) {
          this.appendRecordedMacroEvent(downKey);
        }
      }
    },
    onMouseUp(event) {
      if (this.state === "record") {
        const code = [
          "MouseLeft",
          "MouseWheel",
          "MouseRight",
          "MouseBack",
          "MouseForward",
        ][event.button];
        if (!code) return;
        const downKey = codeKeys["↑" + code];
        this.appendRecordedMacroEvent(downKey);
      }
      if (event.button !== 0) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("keyup", this.onKeyUp);
    document.addEventListener("mousedown", this.onMouseDown);
    document.addEventListener("mouseup", this.onMouseUp);
    document.addEventListener("click", this.onDocumentClick);

    this.onInit();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("keyup", this.onKeyUp);
    document.removeEventListener("mousedown", this.onMouseDown);
    document.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("click", this.onDocumentClick);
  },
};
</script>
<style lang="scss" scoped>
.macro {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 30px;
  }

  .list {
    width: 1100px;
    min-height: 250px;
    border: 1px solid $primary-color;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    margin-bottom: 30px;
    padding: 10px;

    .fields {
      @include flex-center;
      font-size: 30px;
      letter-spacing: 0;
      color: $primary-color;

      .field {
        width: 95px;
        margin: 5px 0;
        background: #333333;
        padding: 5px;
        font-size: 14px;
        position: relative;
      }

      .key-remove {
        @include flex-center;
        display: none;
        width: 25px;
        height: 25px;
        border-radius: 25px;
        background: $primary-color;
        color: #ffffff;
        position: absolute;
        right: -8px;
        top: -8px;
        cursor: pointer;
      }

      &:hover .key-remove {
        display: flex;
      }

      .key-add {
        font-size: 26px;
        margin-left: 2px;
        cursor: pointer;
      }

      .tail-add-menu {
        display: inline-flex;
        align-items: center;
      }

      .time {
        width: 80px;
        font-size: 14px;

        .md-input {
          width: 45px;
        }
      }

      .xy {
        width: 95px;
        margin: 5px 0;
        background: #333333;
        padding: 0;
        position: relative;

        .number {
          width: 100%;
          color: #717171;
          letter-spacing: 0;
          margin: 0;
          padding: 0 5px;
          height: 25px;
          min-height: 25px;
          line-height: 25px;

          .number-input {
            width: 100%;
            text-align: center;
            font-size: 16px;
            height: 25px;
            min-height: 25px;
            line-height: 25px;
          }
        }
      }
    }

    .radio-group {
      width: 120px;
      margin-left: 350px;

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
        justify-content: flex-start;
        background-color: #050505;
        padding: 0 10px;
        margin: 5px;
        border-radius: 5px;
      }
    }
  }

  .click-editor {
    width: 1100px;
    min-height: 250px;
    border: 1px solid $primary-color;
    margin-bottom: 30px;
    padding: 10px 12px;
    display: flex;
    align-items: flex-start;

    .click-editor-inner {
      width: min(420px, 100%);
      display: grid;
      grid-template-columns: minmax(132px, 1.2fr) repeat(2, minmax(108px, 1fr));
      gap: 10px;
    }

    .click-field {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      gap: 6px;
      color: $primary-color;
      min-height: 58px;
      padding: 8px 10px;
      background: #252525;
      border: 1px solid rgba($primary-color, 0.24);
      border-radius: 5px;
    }

    .click-field-key {
      min-width: 0;
    }

    .click-label {
      font-size: 16px;
      line-height: 18px;
      font-weight: 400;
      color: rgba($primary-color, 0.9);
      white-space: nowrap;
    }

    .click-input-field {
      width: 100%;
      max-width: 96px;
      margin: 0;
      min-height: auto;
      padding: 0;

      &::before,
      &::after {
        display: none;
      }

      .click-input {
        width: 100%;
        height: 34px;
        line-height: 34px;
        font-size: 18px;
        font-weight: 600;
      }
    }

    .click-key-input {
      width: 100%;
      min-width: 0;
      max-width: none;
      height: 30px;
      line-height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: 1px solid rgba($primary-color, 0.2);
      box-sizing: border-box;
      color: #ffffff;
      overflow: hidden;
      background: #333333;
      padding: 0 6px;
      font-size: 12px;
      text-align: center;
    }

    .md-suffix {
      color: #9b9b9b;
      font-size: 14px;
    }

    .md-field.md-theme-default:before {
      background-color: rgba($primary-color, 0.35);
    }

    .md-field.md-theme-default.md-focused:after {
      background-color: $primary-color;
    }
  }

  .buttons {
    @include flex-center;
    flex-wrap: wrap;
    width: 1100px;
    color: $primary-color;
    font-size: 18px;
    justify-content: space-between;

    .macro-select {
      width: 150px;
      height: 42px;
      border: 1px solid $primary-color;
      border-radius: 5px;
      padding: 0 5px 0 10px;
      overflow: hidden;
      flex: none;
      margin-left: 10px;
      margin-right: 30px;
    }

    .macro-name,
    .all-time {
      width: 150px;
      margin-left: 10px;
      margin-right: 30px;

      .input {
        width: 100%;
      }
    }

    .all-time {
      width: 100px;
    }

    .radio-group {
      flex: none;
      position: relative;
      display: flex;
      align-items: stretch;
      flex-wrap: nowrap;
      white-space: nowrap;

      &.radio-group-click {
        justify-content: flex-end;
      }

      .active {
        background: $primary-color;
        color: #ffffff;
      }

      .macro-hidden-button {
        visibility: hidden;
        pointer-events: none;
      }
    }

    .macro-type-menu {
      position: absolute;
      top: calc(100% + 8px);
      left: 0;
      z-index: 20;
      min-width: 142px;
      border: 1px solid $primary-color;
      background: #111111;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    }

    .macro-type-menu-item {
      color: $primary-color;
      padding: 12px 16px;
      cursor: pointer;
      white-space: nowrap;
      font-size: 16px;
      line-height: 22px;

      &:hover {
        background: $primary-color;
        color: #ffffff;
      }
    }

    .macro-add-menu {
      position: relative;
      display: inline-flex;
      height: 100%;
      margin-right: -1px;
      z-index: 1;

      .macro-add-button {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
      }
    }

    .title {
      @include flex-center;
      color: $primary-color;
      width: 1100px;
      justify-content: flex-start;
      justify-content: space-between;

      .switch {
        margin-left: 10px;
        margin-right: 630px;
      }

      .progress {
        width: 200px;
        flex: none;
        margin-left: 20px;
      }
    }

    .offset {
      @include flex-center;
      width: 1100px;
      justify-content: flex-start;
    }

    .slider {
      width: 200px;
      margin: 0 40px;
    }

    .offset-input {
      width: 50px;
      margin-right: 100px;

      .input {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.macro {
  .list .fields .field {
    .key-select {
      .md-input {
        font-size: 1em;
      }

      .md-icon {
        display: none;
      }
    }
    .key-input {
      width: 100%;
      height: 40px;
      line-height: 40px;
      max-width: 100%;
      display: block;
      cursor: pointer;
      font-size: 1em;
      border: 0;
      color: #ffffff;
      overflow: hidden;
    }
    .time-input {
      font-size: 1em;
    }

    &:hover .key-select {
      .md-icon {
        display: inline-flex;
      }
    }
  }

  .macro-field {
    width: auto;
    height: auto;
    min-height: auto;
    margin: 0;
    padding: 0;

    &::before,
    &::after {
      display: none;
    }
  }

  .progress {
    .ant-progress-inner {
      background-color: #333333;
    }
    .ant-progress-text {
      color: $primary-color;
    }
  }
}

body:has(.macro-component) > div[class*="md-menu"] {
  position: fixed !important;
  min-height: 0 !important;
  height: auto !important;
  margin: 0 !important;
}

body:has(.macro-component) > .md-menu-content-container {
  position: fixed !important;
  min-height: 0 !important;
  height: auto !important;
  margin: 0 !important;
}
</style>
